import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedLocationView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'locations'

  removeFilter: (value) ->
    @searchQuery.removeLocation(value)
